import { UserData } from "@frontend-monorepo/parking-lot-map";
import { Observable } from "rxjs";

export abstract class UserBase {
    abstract fetchAccountInfo(): Observable<UserData>;
    abstract fetchAccountInfoById(userId: number): Observable<UserData>;
}